import { render } from "./chatMic.vue?vue&type=template&id=034f0047&scoped=true&ts=true"
import script from "./chatMic.vue?vue&type=script&lang=ts"
export * from "./chatMic.vue?vue&type=script&lang=ts"

import "./chatMic.vue?vue&type=style&index=0&id=034f0047&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034f0047"]])

export default __exports__